import {Component} from '@angular/core';

@Component({
  selector: 'app-assoc-words',
  templateUrl: './assoc-words.component.html',
  styleUrls: ['./assoc-words.component.css']
})
export class AssocWordsComponent {
}
